module.exports = {
  visitors: {
    category: 'visitors',
    type: 'number',
  },
  visits: {
    category: 'visitors',
    type: 'number',
  },
  pageviews: {
    category: 'visitors',
    type: 'number',
  },
  uniquePageviews: {
    category: 'visitors',
    type: 'number',
  },
  events: {
    category: 'conversion',
    type: 'number',
  },
  eventTotalValue: {
    category: 'conversion',
    type: 'number',
  },
  eventAvgValue: {
    category: 'conversion',
    type: 'number',
  },
  eventMaxValue: {
    category: 'conversion',
    type: 'number',
  },
  eventMinValue: {
    category: 'conversion',
    type: 'number',
  },
  visitEvents: {
    category: 'visitors',
    type: 'number',
  },
  visitInteractions: {
    category: 'visitors',
    type: 'number',
  },
  visitSiteSearches: {
    category: 'visitors',
    type: 'number',
  },
  visitTotalActions: {
    category: 'visitors',
    type: 'number',
  },
  visitAvgActions: {
    category: 'visitors',
    type: 'number',
  },
  visitMaxActions: {
    category: 'visitors',
    type: 'number',
  },
  goalConvertedVisits: {
    category: 'conversion',
    type: 'number',
  },
  conversionVisits: {
    category: 'conversion',
    type: 'number',
  },
  conversions: {
    category: 'conversion',
    type: 'number',
  },
  conversionVisitors: {
    category: 'conversion',
    type: 'number',
  },
  firstConversionDate: {
    category: 'conversion',
    type: 'datetime',
    excludeDateFilter: true,
  },
  lastConversionDate: {
    category: 'conversion',
    type: 'datetime',
    excludeDateFilter: true,
  },
  conversionRate: {
    category: 'conversion',
    type: 'percent',
  },
  visitsBeforeConversion: {
    category: 'conversion',
    type: 'number',
  },
  daysBeforeConversion: {
    category: 'conversion',
    type: 'number',
  },
  revenue: {
    category: 'conversion',
    type: 'currency',
  },
  revenuePerVisit: {
    category: 'conversion',
    type: 'currency',
  },
  siteSearches: {
    category: 'siteSearch',
    type: 'number',
  },
  uniqueSiteSearches: {
    category: 'siteSearch',
    type: 'number',
  },
  siteSearchResults: {
    category: 'siteSearch',
    type: 'number',
  },
  siteSearchAvgResults: {
    category: 'siteSearch',
    type: 'number',
  },
  siteSearchPages: {
    category: 'siteSearch',
    type: 'number',
  },
  siteSearchExitRate: {
    category: 'siteSearch',
    type: 'percent',
  },
  pageviewsFollowingSiteSearch: {
    category: 'siteSearch',
    type: 'number',
  },
  pageviewsFollowingSiteSearchRate: {
    category: 'siteSearch',
    type: 'percent',
  },
  outlinks: {
    category: 'behavior',
    type: 'number',
  },
  uniqueOutlinks: {
    category: 'behavior',
    type: 'number',
  },
  downloads: {
    category: 'behavior',
    type: 'number',
  },
  uniqueDownloads: {
    category: 'behavior',
    type: 'number',
  },
  totalVisitTime: {
    category: 'engagement',
    type: 'seconds',
  },
  avgVisitTime: {
    category: 'engagement',
    type: 'seconds',
  },
  totalTimeSpent: {
    category: 'engagement',
    type: 'seconds',
  },
  avgTimeSpent: {
    category: 'engagement',
    type: 'seconds',
  },
  avgNetworkTime: {
    category: 'performance',
    type: 'milliseconds',
  },
  avgServerTime: {
    category: 'performance',
    type: 'milliseconds',
  },
  avgTransferTime: {
    category: 'performance',
    type: 'milliseconds',
  },
  avgDomProcessing: {
    category: 'performance',
    type: 'milliseconds',
  },
  avgDomCompletion: {
    category: 'performance',
    type: 'milliseconds',
  },
  avgTimeOnLoad: {
    category: 'performance',
    type: 'milliseconds',
  },
  avgPageLoadTime: {
    category: 'performance',
    type: 'milliseconds',
  },
  bounces: {
    category: 'behavior',
    negative: true,
    type: 'number',
  },
  bounceRate: {
    category: 'behavior',
    negative: true,
    type: 'percent',
  },
  exits: {
    category: 'behavior',
    negative: true,
    type: 'number',
  },
  exitRate: {
    category: 'behavior',
    negative: true,
    type: 'percent',
  },
  entries: {
    category: 'behavior',
    type: 'number',
  },
  newVisitors: {
    category: 'engagement',
    type: 'number',
  },
  returningVisitors: {
    category: 'engagement',
    type: 'number',
  },
  surveyResponses: {
    category: 'survey',
    type: 'number',
  },
  avgVisitCount: {
    category: 'visitors',
    type: 'number',
  },
};
